import { render, staticRenderFns } from "./SuccessfulAuthenticationDoctor.vue?vue&type=template&id=5d90acb4&scoped=true"
import script from "./SuccessfulAuthenticationDoctor.vue?vue&type=script&lang=js"
export * from "./SuccessfulAuthenticationDoctor.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulAuthenticationDoctor.vue?vue&type=style&index=0&id=5d90acb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90acb4",
  null
  
)

export default component.exports